import layout from '@/views/layout/layout.vue'
const mandiInfoList = r => require.ensure([], () => r(require('@/views/marketing/mandiInfo/list.vue')), 'group-marketing-mandiInfo')

const marketingMandiInfo = [
  {
    path: '/marketing/mandiInfo',
    name: 'marketing-mandiInfo',
    component: layout,
    redirect: '/marketing/mandiInfo/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: mandiInfoList,
        name: 'marketing-mandiInfo-list',
        meta: {
          displayName: '获取信息管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingMandiInfo



// WEBPACK FOOTER //
// ./src/router/marketing/mandiInfo.js